import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		avatar: {
		},
	} satisfies Record<string, CSSObject>);
};